module.exports = __webpack_public_path__ + "img/partner_img7.d67a86fe.png";